import { render } from "./faqVue.vue?vue&type=template&id=1bbf23b2&scoped=true"
import script from "./faqVue.vue?vue&type=script&lang=js"
export * from "./faqVue.vue?vue&type=script&lang=js"

import "./faqVue.vue?vue&type=style&index=0&id=1bbf23b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bbf23b2"]])

export default __exports__